import { render, staticRenderFns } from "./AgendeListPage.vue?vue&type=template&id=84dfe78c"
import script from "./AgendeListPage.vue?vue&type=script&lang=js"
export * from "./AgendeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports